import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import { closeModal, openModal } from "../../state/modalSlice";
import AvatarLoaderModal from "../../modals/avatarLoad";
import { formatDateTimeStandard } from "../../utils";
import { UserPersonalData, UserPhoto } from "../../types";
import { handleOpenDatailPhoto } from "../../modals/functions";

const UserPageWidget = (props: { editable?: boolean, profile: UserPersonalData, files: UserPhoto[] }) => {
  const State = useSelector((state: RootState) => state);
  const { profile, files }= props
  const dispatch = useDispatch();

  const mainPhotos = files.filter(item => item.category === "main");

  const maxId = Math.max(...mainPhotos.map(item => item.id), 0)
  
  const mainPhoto = mainPhotos.find(item => item.id === maxId);

  const photo = mainPhoto?.url.replace("uploads/", "/files/") || "/images/profile.png"

  const handleOpenModal = () => {
    if (!props?.editable) {
      handleOpenDatailPhoto(photo, `Фото: ${profile?.last_name || ""} ${profile?.first_name || ""}`);
      return;
    }
    dispatch(openModal({ component: AvatarLoaderModal,context: {
      defaultPhotoUrl: '/images/profile.png',
      onSave: (file: File) => {
        console.log('Сохранено фото:', file.name);
      },
      closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
    }, }));
  };


  return (
    <div className="profileWidget">
      <div className="panelInner" onClick={handleOpenModal}>
        <div className="row profileImgRow">
          <img src={mainPhoto?.url.replace("uploads/", "/files/") || "/images/profile.png"} />
        </div>
        <div className="profileBodyItem">
          <p className="labelText">ФИО:</p>
          <p className="labelHeadingText">{`${profile?.last_name || ""} ${profile?.first_name || ""}`}</p>
        </div>
        <div className="profileBodyItem">
          <p className="labelText">Роль/Должность:</p>
          <p className="labelHeadingText">
            {profile?.role && <div className="userRoleInfoText">{profile?.role}</div>}
          </p>
          {/* <p className="clickableActionText">Изменить роль</p> */}
        </div>
        <div className="profileBodyItem">
          <p className="labelText">Обновлен в последний раз:</p>
          <p className="labelText">{profile?.date_updated? formatDateTimeStandard(profile?.date_updated) : ""}</p>
        </div>
      </div>
    </div>
  );
};

export default UserPageWidget;
